import * as yup from "yup";
import { LedgerAccountsTypeValues } from "../utils";

export function LedgerAccountsValidate() {
    return yup.object().shape({
        ledger_account_code: yup.string().required("Conta não informada."),
        name: yup.string().required("Nome não informado."),
        account_type: yup
            .string()
            .nullable()
            .oneOf([...LedgerAccountsTypeValues, null], "Tipo de conta inválido."),
    });
}

export function ChartAccountsValidate() {
    return yup.object().shape({
        name: yup.string().required("Nome é obrigatório").min(3, "Nome deve ter mais que três caracteres"),
        ledger_accounts: yup.array().required("Contas não informados").min(1, "Nenhuma conta informado").of(LedgerAccountsValidate()),
    });
}
